import React, { useEffect, useRef, useState } from 'react';

import MRadioView from './MRadio.view';

type Props = {
  id?: string;
  name: string;
  checked: boolean;
  value?: React.InputHTMLAttributes<HTMLInputElement>['value'];
  className?: string;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const MRadio: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const [checkedState, setCheckedState] = useState<boolean>(props.checked);

  const inputRef = useRef<HTMLInputElement>(null);

  const changeBox = () => {
    setCheckedState((prev: boolean) => {
      const newValue = !prev;

      return newValue;
    });

    inputRef.current?.click();
  };

  useEffect(() => {
    const checked = props.checked;

    if (checked === undefined) {
      return;
    }

    setCheckedState(() => checked);
  }, [props.checked]);

  return (
    <MRadioView
      inputRef={inputRef}
      checked={checkedState}
      id={props.id}
      value={props.value}
      name={props.name}
      className={props.className}
      disabled={props.disabled}
      onChange={props.onChange}
      onClick={changeBox}
    >
      {props.children}
    </MRadioView>
  );
};

MRadio.displayName = 'MRadio';
MRadio.defaultProps = {};

export default MRadio;
